import React from 'react';

const LegalNotice: React.FC = () => {
    return (
        <div className="pt-24 pb-20 bg-dark-900">
            <div className="container px-4 mx-auto">
                <div className="mx-auto max-w-4xl">
                    <h1 className="mb-8 text-4xl font-bold text-white">Legal Notice</h1>

                    <div className="prose prose-invert">
                        <p className="mb-6 text-dark-300">Last updated: {new Date().toLocaleDateString()}</p>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">Company Information</h2>
                            <p className="mb-4 text-dark-300">
                                WinMax Optimizer is operated by:
                            </p>
                            <div className="mb-6 text-dark-300">
                                <p>Dubai Free Zone.</p>
                            </div>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">Intellectual Property</h2>
                            <p className="mb-4 text-dark-300">
                                All content, trademarks, and intellectual property on this website are owned by
                                WinMax. The WinMax Optimizer software and all related materials are
                                protected by copyright and intellectual property laws.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">Disclaimer</h2>
                            <p className="mb-4 text-dark-300">
                                While we strive to keep information on this website accurate and up to date, we make
                                no representations or warranties about the completeness, accuracy, reliability, or
                                availability of the website or the information, products, services, or related
                                graphics contained on the website.
                            </p>
                        </section>

                        <section>
                            <h2 className="mb-4 text-2xl font-semibold text-white">Contact</h2>
                            <p className="text-dark-300">
                                For legal inquiries, please contact{' '}
                                <a href="mailto:legal@winmaxoptimizer.com" className="text-primary-400 hover:text-primary-300">
                                    support@winmaxoptimizer.com
                                </a>
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LegalNotice;
